import React from 'react';
import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';
import Button from '@base/Button/Button';
import { getImage } from '@utils/imageHelper';

interface IPreSubscriptionBannerProps {
  title: string;
  description: string;
  handleButtonClick: () => void;
  isGTP: boolean;
}

const Wrapper = styled.div<{ $isGTP: boolean }>`
  background: rgb(8, 189, 128, 0.1);
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  grid-column: span 18;
  display: flex;
  margin-top: -${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_6B};
  background-image: ${({ $isGTP }) =>
    `url(${getImage(
      $isGTP
        ? 'syllabus/pre-subscribed_plus.png'
        : 'syllabus/pre-subscribed_iconic.svg'
    )})`};
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: 280px 252px;
`;

const InfoWrapper = styled.div`
  padding: ${Spacings.SPACING_12B} 0 ${Spacings.SPACING_12B}
    ${Spacings.SPACING_10B};
  max-width: 480px;
`;

const StyP1 = styled(P1)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_6B};
  line-height: ${Spacings.SPACING_5B};
`;

const StyH3 = styled(H3)`
  line-height: ${Spacings.SPACING_7B};
`;

const PreSubscriptionBanner: React.FC<IPreSubscriptionBannerProps> = ({
  title,
  description,
  handleButtonClick,
  isGTP
}) => {
  return (
    <Wrapper $isGTP={isGTP}>
      <InfoWrapper>
        <StyH3>{title}</StyH3>
        <StyP1 color="var(--color-i-gray)">{description}</StyP1>
        <Button
          // @ts-ignore
          label="Get subscription"
          onClick={handleButtonClick}
        />
      </InfoWrapper>
    </Wrapper>
  );
};

export default PreSubscriptionBanner;
